import { formatPrice } from '@grandvisionhq/utils';

// returns discounted value as either `-€##` or `-##%`
const getDiscount = (locale, currencyCode, discountType, discountedPrice)=>{
    // check that discounted price exist
    if (!discountedPrice || !discountType || !currencyCode) return undefined;
    if (discountType.toLowerCase() === 'absolute') {
        return `-${formatPrice({
            locale,
            value: discountedPrice,
            currency: currencyCode,
            isCentAmount: false
        })}`;
    } else if (discountType.toLowerCase() === 'relative') {
        return `-${discountedPrice}%`;
    } else {
        return undefined;
    }
};

export { getDiscount };
//# sourceMappingURL=get-discount.js.map
